<div class="wrapper">
    @if(userIsNotGuest()) {
    <div id="sidebar" [class.active]="opened">
        <app-user-menu (menuItemClicked)="navigateTo($event)"></app-user-menu>
    </div>
    @if(opened) {
    <div class="overlay" (click)="onPageClick($event)"></div>
    }
    }
    <div id="page" [class.no-sidebar]="!userIsNotGuest()" [class.active]="opened">
        <div class="page-content">
            <div class="navbar">
                <app-navbar #navbar (onSideMenuOpened)="toggleSideMenu()"
                    (onLinkClicked)="navigateTo($event)"></app-navbar>
            </div>
            <div class="main-content">
                <router-outlet />
            </div>
            <div class="footer">

            </div>
        </div>
    </div>
</div>
@if(isProduction) {
<div>
    <!-- Google Tag Manager -->
    <script>
        (function (w, d, s, l, i) {
            w[l] = w[l] || []; w[l].push({
                'gtm.start':
                    new Date().getTime(), event: 'gtm.js'
            }); var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s), dl = l != 'dataLayer' ? '&l=' + l : ''; j.async = true; j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl; f.parentNode.insertBefore(j, f);
        })(window, document, 'script', 'dataLayer', 'GTM-WRSKPRT');</script>
    <!-- End Google Tag Manager -->
</div>
}